import { ExcludedPlatforms } from 'app/types/excludedPlatforms'
import { gql } from 'graphql-request'
import { GenericBlock } from '../generic'
import { ColorEnum } from 'app/utils/mapColors'

export const landingCollectiblesFragment = gql`
  fragment landingCollectiblesFragment on LandingCollectibles {
    id
    title
    collectibles {
      id
      title
      quarter
      slug
      hasContent
      availableFrom
      backgroundColour
      availableUntil
      thumbnail {
        url
        sizes {
          square {
            url
          }
        }
      }
    }
    excludedPlatforms {
      ios
      android
      web
    }
  }
`

export interface LandingCollectibleItem {
  id: string
  title: string
  quarter: string
  slug?: string
  hasContent?: boolean
  availableFrom?: string
  availableUntil?: string
  backgroundColour?: ColorEnum
  thumbnail?: {
    url: string
    sizes?: {
      square?: {
        url?: string
      }
    }
  }
}

export interface LandingCollectibles
  extends GenericBlock<'LandingCollectibles'> {
  title?: string
  collectibles: LandingCollectibleItem[]
  excludedPlatforms?: ExcludedPlatforms
}

export type CollectThemAllItem = LandingCollectibleItem
export type CollectThemAll = LandingCollectibles
